/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateFailureTypeCommand
 */
export interface UpdateFailureTypeCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdateFailureTypeCommand
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateFailureTypeCommand
     */
    name?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateFailureTypeCommand
     */
    taskIds?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateFailureTypeCommand
     */
    description?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateFailureTypeCommand
     */
    specialCase?: boolean | null;
}

export function UpdateFailureTypeCommandFromJSON(json: any): UpdateFailureTypeCommand {
    return UpdateFailureTypeCommandFromJSONTyped(json, false);
}

export function UpdateFailureTypeCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateFailureTypeCommand {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'taskIds': !exists(json, 'taskIds') ? undefined : json['taskIds'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'specialCase': !exists(json, 'specialCase') ? undefined : json['specialCase'],
    };
}

export function UpdateFailureTypeCommandToJSON(value?: UpdateFailureTypeCommand | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'taskIds': value.taskIds,
        'description': value.description,
        'specialCase': value.specialCase,
    };
}


